import { LeftOutlined } from '@ant-design/icons';
import { Button, type ButtonProps } from '@arkestro/arkestro-design-system';
import useTranslation from 'next-translate/useTranslation';
import { safeKeyPress } from 'utils/accessibility';

interface BackButtonProps extends ButtonProps {
  hideIcon?: boolean;
  onClick: () => void;
  style?: any;
}

export const BackButton = ({
  onClick,
  className,
  children,
  hideIcon,
  style,
}: BackButtonProps) => {
  const { t } = useTranslation('common');
  return (
    <Button
      className={className}
      data-testid="back-button"
      onClick={onClick}
      onKeyPress={e => safeKeyPress(e, onClick)}
      style={style}
      tabIndex={0}
    >
      {!hideIcon && <LeftOutlined />}
      {children || t('general.back')}
    </Button>
  );
};
